module.exports = "/images/azulcargopb.png?9847b3442e520c6a126a9b8d293c9454";